import { useEffect, useState, useCallback, Fragment } from "react";
import { Trash2, Inbox } from "lucide-react";
import { toast } from "sonner";
import { api, fmtDate, formatError } from "@/lib/api";
import { Empty } from "@/components/workspace/Panels";

export function SubmissionsView({ projectId }) {
  const [rows, setRows] = useState(null);
  const load = useCallback(() => api.get(`/projects/${projectId}/submissions`).then((r) => setRows(r.data)), [projectId]);
  useEffect(() => { load(); }, [load]);
  const remove = async (sid) => { try { await api.delete(`/projects/${projectId}/submissions/${sid}`); load(); } catch (e) { toast.error(formatError(e)); } };

  if (!rows) return null;
  if (!rows.length) return <div className="h-full" data-testid="submissions-empty"><Empty><span className="flex flex-col items-center gap-2"><Inbox className="w-6 h-6" />Aquí llegarán los mensajes de los formularios de contacto, reservas o cotizaciones de tu sitio publicado.</span></Empty></div>;
  return (
    <div className="h-full overflow-y-auto scroll-thin p-5 space-y-3" data-testid="submissions-view">
      <p className="text-xs text-slate-500">{rows.length} envío(s). Los marcados como «prueba» vienen de la vista previa.</p>
      {rows.map((s) => (
        <div key={s.id} className="rounded-xl border border-[#222B40] p-4" data-testid={`submission-${s.id}`}>
          <div className="flex justify-between items-center text-xs">
            <span className="text-cyan-300">{s.form}{s.test && <span className="ml-2 text-amber-300">prueba</span>}</span>
            <span className="flex items-center gap-3 text-slate-500">{fmtDate(s.created_at)}<button onClick={() => remove(s.id)} data-testid={`submission-delete-${s.id}`} className="hover:text-red-300"><Trash2 className="w-3.5 h-3.5" /></button></span>
          </div>
          <dl className="mt-2 grid grid-cols-[auto_1fr] gap-x-4 gap-y-1 text-sm">
            {Object.entries(s.data).map(([k, v]) => <Fragment key={k}><dt className="text-slate-500">{k}</dt><dd className="text-slate-200 break-words">{String(v)}</dd></Fragment>)}
          </dl>
        </div>
      ))}
    </div>
  );
}
